import { render, staticRenderFns } from "./MaskSetting.vue?vue&type=template&id=f9875a96&scoped=true"
import script from "./MaskSetting.vue?vue&type=script&lang=js"
export * from "./MaskSetting.vue?vue&type=script&lang=js"
import style0 from "./MaskSetting.vue?vue&type=style&index=0&id=f9875a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9875a96",
  null
  
)

export default component.exports